import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  clientAgreementList: { loading: false, data: null, error: null },
};

export const clientAgreementReportSlice = createSlice({
  name: "clientAgreementReport",
  initialState,
  reducers: {
    fetchClientAgreementListRequest: (state, action) => {
      state.clientAgreementList.loading = true;
      state.clientAgreementList.error = null;
    },
    fetchClientAgreementListSuccess: (state, action) => {
      state.clientAgreementList.data = action.payload;
      state.clientAgreementList.loading = false;
      state.clientAgreementList.error = null;
    },
    fetchClientAgreementListFailure: (state, action) => {
      state.clientAgreementList.data = null;
      state.clientAgreementList.loading = false;
      state.clientAgreementList.error = action.payload;
    },
  },
});

export const {
  fetchClientAgreementListRequest,
  fetchClientAgreementListSuccess,
  fetchClientAgreementListFailure,
} = clientAgreementReportSlice.actions;

export const getClientAgreementListState = (store) =>
  store.clientAgreementReport?.clientAgreementList;

export default clientAgreementReportSlice.reducer;
